export default {
  // About Us Page
  'about.hero.subtitle': 'Our Story',
  'about.hero.title': 'About Us',
  'about.hero.description': 'A forward-thinking business holding committed to excellence, innovation and sustainable development in each of our operating sectors.',
  'about.history.title': 'Our History',
  'about.history.p1': 'IVG CORP - Inkavida Corporation was born from the vision of creating an integrated business ecosystem that generates sustainable value in multiple sectors of the economy. With more than 15 years of experience, we have consolidated our presence in the Latin American market.',
  'about.history.p2': 'From our beginnings in the natural products sector with Inkavida Global, we have strategically expanded our operations towards retail, real estate development, manufacturing and financial services, creating synergies that strengthen each of our companies.',
  'about.history.p3': 'Today, we are a benchmark for successful business diversification, with a business model that combines financial strength, constant innovation and social commitment.',
  'about.leadership.title': 'Leadership',
  'about.ceo.role': 'CEO & FOUNDER',
  'about.ceo.title': 'Chief Executive Officer',
  'about.ceo.section_title': 'Our CEO',
  'about.ceo.name': 'Jorge Marcacuzco',
  'about.ceo.position': 'Visionary Entrepreneur',
  'about.ceo.description1': 'Visionary entrepreneur with more than 15 years of experience in developing integrated business ecosystems. Jorge has led the transformation of IVG CORP from its beginnings to becoming one of the most diversified holdings in Latin America.',
  'about.ceo.description2': 'His strategic approach to creating synergies between companies and his vision of sustainability have been fundamental to the exponential growth of the group, covering sectors such as natural products, retail, real estate and manufacturing.',
  'about.ceo.description3': 'Under his leadership, IVG CORP has maintained sustained growth, prioritizing innovation, social responsibility and value creation for all stakeholders.',
  'about.ceo.experience': 'Experience',
  'about.ceo.experience_years': '+15 years in business management',
  'about.ceo.companies': 'Companies',
  'about.ceo.companies_count': '6 group companies',
  'about.ceo.learn_more': 'Learn more about Jorge Marcacuzco',
  'about.culture.collaboration': 'Collaboration',
  'about.culture.collaboration_desc': 'We work together to achieve common goals',
  'about.culture.innovation': 'Innovation',
  'about.culture.innovation_desc': 'We drive creativity and new ideas',
  'about.culture.excellence': 'Excellence',
  'about.culture.excellence_desc': 'We seek continuous improvement in everything we do',
  'about.culture.sustainability': 'Sustainability',
  'about.culture.sustainability_desc': 'Committed to the future of the planet',
  'about.mission.title': 'Mission',
  'about.mission.content': 'Create sustainable value through a diversified business ecosystem, driving innovation, operational excellence and comprehensive development of our employees, customers and communities.',
  'about.vision.title': 'Vision',
  'about.vision.content': 'To be the leading business holding in Latin America, recognized for our strategic integration capacity, continuous innovation and generation of sustainable growth opportunities in all our operating sectors.',
  'about.values.title': 'Values',
  'about.values.integrity': 'Integrity and transparency',
  'about.values.operational_excellence': 'Operational excellence',
  'about.values.continuous_innovation': 'Continuous innovation',
  'about.values.social_responsibility': 'Social responsibility',
  'about.values.teamwork': 'Teamwork',
  'about.culture.title': 'Corporate Culture',
  'about.culture.description': 'We foster a collaborative, inclusive work environment oriented towards the professional and personal growth of our employees',
  'about.strategy.title': 'Strategic Approach',
  'about.strategy.description': 'Our strategy is based on solid pillars that guide our growth and expansion',
  'about.cta.title': 'Join Our Team',
  'about.cta.description': 'Join a business holding in constant growth and development',
  'about.cta.button': 'Contact Us',

  // Companies Page
  'companies.hero.subtitle': 'Our Business Ecosystem',
  'companies.hero.title': 'Group Companies',
  'companies.hero.description': 'Six consolidated companies working in synergy to create sustainable value in multiple sectors of the economy',
  'companies.megatendencias': 'Megatrends',
  'companies.inka_drive.name': 'Inka Drive',
  'companies.inka_drive.description': 'Transportation app that connects drivers and passengers, offering safe and convenient trips throughout the city.',
  'companies.inkavida_global.sector': 'Natural Products and Wellness',
  'companies.inkavida_global.description': 'Leading company in natural products and wellness, committed to the comprehensive health of our customers.',
  'companies.inkavida_global.service1': 'Premium nutritional supplements',
  'companies.inkavida_global.service2': 'Natural wellness products',
  'companies.inkavida_global.service3': 'Comprehensive health consulting',
  'companies.inkavida_global.service4': 'Personalized nutrition programs',
  'companies.club_inkavida.sector': 'Memberships and Loyalty',
  'companies.club_inkavida.description': 'Exclusive membership community that offers unique benefits and loyalty programs for our members.',
  'companies.club_inkavida.service1': 'VIP memberships with exclusive benefits',
  'companies.club_inkavida.service2': 'Access to pools and recreational areas',
  'companies.club_inkavida.service3': 'Bungalows for relaxation and rest',
  'companies.club_inkavida.service4': 'Bar and restaurant with specialties',
  'companies.inmobiliaria_inkavida.sector': 'Real Estate Development',
  'companies.inmobiliaria_inkavida.description': 'Development of productive lots focused on sustainable agriculture, fish farming, rural tourism and capital gains generation.',
  'companies.inmobiliaria_inkavida.service1': 'High-yield productive lots',
  'companies.inmobiliaria_inkavida.service2': 'Comprehensive fish farm development',
  'companies.inmobiliaria_inkavida.service3': 'High value-added plantations',
  'companies.inmobiliaria_inkavida.service4': 'Ecotourism development and capital gains',
  'companies.hipermercados_inkavida.sector': 'Retail and Commerce',
  'companies.hipermercados_inkavida.description': 'Company specialized in rental and sale of strategic commercial premises, with comprehensive management of shopping centers.',
  'companies.hipermercados_inkavida.service1': 'Strategic commercial premises rental',
  'companies.hipermercados_inkavida.service2': 'Premium commercial space sales',
  'companies.hipermercados_inkavida.service3': 'Comprehensive shopping center management',
  'companies.hipermercados_inkavida.service4': 'Commercial investment consulting',
  'companies.inversiones_inkavida.sector': 'Financial Services',
  'companies.inversiones_inkavida.description': 'Financial entity regulated by SBS, specialized in investment capture and mortgage-backed loans.',
  'companies.inversiones_inkavida.service1': 'Guaranteed investment opportunities',
  'companies.inversiones_inkavida.service2': 'Mortgage loans with competitive rates',
  'companies.inversiones_inkavida.service3': 'Specialized risk assessment',
  'companies.inversiones_inkavida.service4': 'SBS regulation and supervision',
  'companies.inka_drive.sector': 'Technology and Transportation',
  'companies.inka_drive.service1': '24/7 urban transportation service',
  'companies.inka_drive.service2': 'Verified and trained drivers',
  'companies.inka_drive.service3': 'Competitive and transparent rates',
  'companies.inka_drive.service4': 'Real-time trip tracking',
  'companies.visit_button': 'Visit',
  'companies.sectors.natural': 'Natural Products and Wellness',
  'companies.sectors.membership': 'Memberships and Loyalty',
  'companies.sectors.realestate': 'Real Estate Development',
  'companies.sectors.retail': 'Retail and Commerce',
  'companies.sectors.financial': 'Financial Services',
  'companies.sectors.manufacturing': 'Manufacturing and Production',
  'companies.services.title': 'Main Services:',
  'companies.integration.title': 'Strategic Integration',
  'companies.integration.description': 'Our companies work in a coordinated manner, creating synergies that enhance the value of each operation',
  'companies.integration.value_chain.title': 'Value Chain',
  'companies.integration.value_chain.description': 'From manufacturing to point of sale, we control the entire value chain to guarantee quality and efficiency.',
  'companies.integration.customer_base.title': 'Customer Base',
  'companies.integration.customer_base.description': 'We share a loyal customer base that benefits from complementary products and services.',
  'companies.integration.innovation.title': 'Shared Innovation',
  'companies.integration.innovation.description': 'Best practices and innovations are replicated throughout the group, accelerating growth.',
  'companies.cta.title': 'Interested in Collaborating?',
  'companies.cta.description': 'Explore business opportunities with our companies',
  'companies.cta.button': 'Contact Now',

  // Contact Page
  'contact.hero.subtitle': 'We Are Here For You',
  'contact.hero.title': 'Support',
  'contact.hero.description': 'Connect with us and discover how we can work together',
  'contact.info.title': 'Support Information',
  'contact.info.description': 'Our team is ready to address your inquiries and explore collaboration opportunities with the IVG ecosystem.',
  'contact.office.title': 'Main Office',
  'contact.office.address': 'Mz.16, Lt.5, Villa de Jesús. Villa el Salvador, Lima, Peru',
  'contact.office.reference': 'Ref. Next to Unicachi Market or Mega Plaza Villa el Salvador',
  'contact.email.title': 'Corporate Email',
  'contact.email.address': 'soporte@ivgcorp.com',
  'contact.phone.title': 'Mobile',
  'contact.phone.number': '(+51) 977 856 356',
  'contact.phone2.title': 'Phone Center',
  'contact.phone2.number': '(01) 701 7676',
  'contact.hours.title': 'Business Hours',
  'contact.hours.weekdays': 'Monday to Saturday: 9:00 AM - 6:00 PM',
  'contact.hours.sunday': 'Sunday: Closed',
  'contact.jobs.title': 'Looking for Work?',
  'contact.jobs.description': 'Send your CV and join our corporate team',
  'contact.jobs.button': 'Job Opportunities',
  'contact.form.name_placeholder': 'Your full name',
  'contact.form.email_placeholder': 'your@email.com',
  'contact.form.phone_placeholder': '+51 XXX XXX XXX',
  'contact.form.company_select': 'Select a company',
  'contact.form.company_other': 'Other company',
  'contact.form.subject_select': 'Select a subject',
  'contact.form.subject_general': 'General Inquiry',
  'contact.form.subject_business': 'Business Opportunities',
  'contact.form.subject_investments': 'Investments',
  'contact.form.subject_suppliers': 'Suppliers',
  'contact.form.subject_hr': 'Human Resources',
  'contact.form.subject_other': 'Other',
  'contact.form.message_placeholder': 'Tell us how we can help you...',
  'contact.form.character_limit': 'Maximum 500 characters',
  'contact.map.title': 'Our Location',
  'contact.map.description': 'Visit us at our offices in Villa el Salvador',
  'contact.business.title': 'Looking for Business Opportunities?',
  'contact.business.description': 'If you are interested in collaborating with any of our companies or exploring investment opportunities, our business development team is ready to assist you.',
  'contact.form.title': 'Send Us a Message',
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone',
  'contact.form.company': 'Company',
  'contact.form.subject': 'Subject',
  'contact.form.message': 'Message',
  'contact.form.submit': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.form.success': 'Message sent successfully! We will contact you soon.',
  'contact.form.error': 'There was an error sending the message. Please try again.',

  // Gallery Page
  'gallery.hero.subtitle': 'Corporate Multimedia',
  'gallery.hero.title': 'IVG CORP Gallery',
  'gallery.hero.description': 'Discover our facilities, corporate events and the team that drives the growth of the business group',
  'gallery.filters.all': 'All',
  'gallery.filters.facilities': 'Facilities',
  'gallery.filters.events': 'Events',
  'gallery.filters.team': 'Team',
  'gallery.filters.projects': 'Projects',
  'gallery.modal.close': 'Close',
  'gallery.modal.more_info': 'More Information',

  // News Page
  'news.hero.subtitle': 'Corporate News',
  'news.hero.title': 'News and Announcements',
  'news.hero.description': 'Stay informed about the latest developments, expansions and achievements of the business group',
  'news.read_more': 'Read more',
  'news.modal.close': 'Close',
  'news.modal.more_info': 'More Information',
  'news.newsletter.title': 'Subscribe to Our Newsletter',
  'news.newsletter.description': 'Receive the latest news and updates from the business group directly in your email',
  'news.newsletter.placeholder': 'Your email address',
  'news.newsletter.button': 'Subscribe',

  // Careers Page
  'careers.hero.subtitle': 'Join Our Team',
  'careers.hero.title': 'Job Opportunities',
  'careers.hero.description': 'At IVG CORP we seek exceptional talent that shares our vision of excellence and innovation. Send us your CV and our team will analyze it for future opportunities.',
  'careers.benefits.title': 'Why work at IVG CORP?',
  'careers.benefits.subtitle': 'We offer a dynamic work environment with professional growth opportunities',
  'careers.benefits.growth.title': 'Professional Growth',
  'careers.benefits.growth.description': 'Development and continuous training',
  'careers.benefits.collaborative.title': 'Collaborative Environment',
  'careers.benefits.collaborative.description': 'Teamwork and innovation',
  'careers.benefits.competitive.title': 'Competitive Benefits',
  'careers.benefits.competitive.description': 'Compensation and exclusive benefits',
  'careers.benefits.international.title': 'International Projection',
  'careers.benefits.international.description': 'Multinational projects',
  'careers.benefits.innovation.title': 'Innovation',
  'careers.benefits.innovation.description': 'Creativity and new ideas',
  'careers.benefits.stability.title': 'Stability',
  'careers.benefits.stability.description': 'Solid group with 7+ years',
  'careers.form.title': 'Job Opportunities',
  'careers.form.subtitle': 'Complete the form and attach your resume. Our human resources team will review it and contact you if your profile fits our needs.',
  'careers.form.name': 'Full Name',
  'careers.form.name_placeholder': 'Your full name',
  'careers.form.email': 'Email',
  'careers.form.email_placeholder': 'your@email.com',
  'careers.form.phone': 'Phone',
  'careers.form.phone_placeholder': '+51 999 999 999',
  'careers.form.area': 'Area of Interest',
  'careers.form.area_placeholder': 'Select an area',
  'careers.form.area_administration': 'Administration',
  'careers.form.area_finance': 'Finance',
  'careers.form.area_marketing': 'Marketing',
  'careers.form.area_sales': 'Sales',
  'careers.form.area_operations': 'Operations',
  'careers.form.area_hr': 'Human Resources',
  'careers.form.area_technology': 'Technology',
  'careers.form.area_logistics': 'Logistics',
  'careers.form.area_legal': 'Legal',
  'careers.form.area_other': 'Other',
  'careers.form.cv_label': 'Attach CV (PDF, DOC, DOCX) *',
  'careers.form.cv_selected': 'File selected:',
  'careers.form.cv_requirements': 'Maximum 5MB. Formats: PDF, DOC, DOCX',
  'careers.form.cv_error_type': 'Only PDF, DOC or DOCX files are allowed',
  'careers.form.cv_error_size': 'File cannot be larger than 5MB',
  'careers.form.message': 'Message / Presentation',
  'careers.form.message_placeholder': 'Tell us briefly about your experience and why you would like to work at IVG CORP (maximum 500 characters)',
  'careers.form.characters': 'characters',
  'careers.form.submit': 'Submit Application',
  'careers.form.submitting': 'Sending...',
  'careers.form.success': 'Thank you for your application! We have received your CV and will review it soon.',
  'careers.form.error': 'There was an error sending your application. Please try again.',
  'careers.form.privacy': 'By submitting your application, you agree that IVG CORP processes your personal data for recruitment purposes.',
  'careers.stats.employees': 'Employees',
  'careers.stats.companies': 'Group Companies',
  'careers.stats.offices': 'Offices',
  'careers.stats.countries': 'Countries',

  // Locations Page
  'locations.hero.subtitle': 'Global Presence',
  'locations.hero.title': 'Our Locations',
  'locations.hero.description': 'Strategic presence in the main Latin American markets with operations in multiple countries',
  'locations.expansion.title': 'Regional Expansion',
  'locations.expansion.subtitle': 'Operations in 3 countries with continuous expansion plans',
  'locations.stats.offices': 'Offices and Centers',
  'locations.stats.countries': 'Countries',
  'locations.stats.cities': 'Cities',
  'locations.filters.all': 'All Countries',
  'locations.filters.peru': 'Peru',
  'locations.filters.chile': 'Chile',
  'locations.filters.colombia': 'Colombia',
  'locations.headquarters': 'Main Headquarters',
  'locations.all_locations': 'All Locations',
  'locations.contact_info.address': 'Address',
  'locations.contact_info.phone': 'Phone',
  'locations.contact_info.email': 'Email',
  'locations.contact_info.hours': 'Hours',
  'locations.companies_here': 'Companies at this location:',
  'locations.companies_label': 'Companies:',
  'locations.cta.title': 'Need More Information?',
  'locations.cta.description': 'Contact us to learn more about our locations and services',
  'locations.cta.button': 'Contact',

  // FAQ Page
  'faq.hero.subtitle': 'Help Center',
  'faq.hero.title': 'Frequently Asked Questions',
  'faq.hero.description': 'Find answers to the most common questions about IVG CORP and our companies',
  'faq.categories.general': 'General',
  'faq.categories.companies': 'Group Companies',
  'faq.categories.investments': 'Investments and Alliances',
  'faq.categories.employment': 'Employment and Careers',
  'faq.categories.sustainability': 'Sustainability',
  'faq.general.q1': 'What is IVG CORP?',
  'faq.general.a1': 'IVG CORP (Inkavida Corporation) is a multinational business holding that groups six leading companies in different sectors: natural products, memberships, real estate development, retail, investments and transportation technology. Our goal is to create synergies between group companies to offer comprehensive solutions and generate sustainable value.',
  'faq.general.q2': 'What is the business group\'s vision?',
  'faq.general.a2': 'Our vision is to be the leading business holding in Latin America, recognized for operational excellence, constant innovation and commitment to sustainable development. We seek to create an integrated business ecosystem that generates value for our customers, employees and communities.',
  'faq.companies.q1': 'What companies make up IVG CORP?',
  'faq.companies.a1': 'The group consists of six companies:',
  'faq.companies.list1': 'Inkavida Global (natural products and wellness)',
  'faq.companies.list2': 'Club Inkavida (memberships and benefits)',
  'faq.companies.list3': 'Inmobiliaria Inkavida (real estate development)',
  'faq.companies.list4': 'Hipermercados Inkavida (retail)',
  'faq.companies.list5': 'Inversiones Inkavida (financial services)',
  'faq.companies.list6': 'Inka Drive (transportation technology)',
  'faq.companies.q2': 'How can I contact a specific company in the group?',
  'faq.companies.a2': 'Each company has its own contact channels. You can visit our Group Companies section to find specific contact information, or use our general form and we will direct you to the corresponding area.',
  'faq.companies.q3': 'Do the group companies work independently?',
  'faq.companies.a3': 'While each company maintains its operational autonomy and specialization, we work in an integrated way to create synergies and offer complementary solutions. This structure allows us to leverage the strengths of each company while maintaining agility and focus in each sector.',
  'faq.investments.q1': 'How can I invest in IVG CORP?',
  'faq.investments.a1': 'We offer different investment opportunities according to the investor profile. For detailed information on current opportunities, requirements and processes, we invite you to contact Inversiones Inkavida directly through our contact form or by sending an email to inversiones@ivgcorp.com.',
  'faq.investments.q2': 'Does IVG CORP seek strategic alliances?',
  'faq.investments.a2': 'Yes, we are constantly evaluating strategic alliances that add value to our business ecosystem. If you have a collaboration or alliance proposal, you can contact us through alianzas@ivgcorp.com with the details of your proposal.',
  'faq.employment.q1': 'How can I work at IVG CORP?',
  'faq.employment.a1': 'You can send your CV through the Contact section of our website, where you will find the "Job Opportunities" button. Send your CV and our human resources team will evaluate it for current or future positions. If your profile matches our needs, we will contact you.',
  'faq.employment.q2': 'What benefits do you offer employees?',
  'faq.employment.a2': 'We offer a comprehensive benefits package that includes: premium health insurance for the employee, professional development programs and continuous training, work flexibility, performance bonuses, collaborative environment, and recognition and career growth programs.',
  'faq.employment.q3': 'What professional growth opportunities do you offer?',
  'faq.employment.a3': 'At IVG CORP we value the development of our employees. We offer continuous training programs, mentoring, internal promotion opportunities and the possibility of working in different areas of our companies to expand professional experience.',
  'faq.sustainability.q1': 'What social responsibility initiatives does IVG CORP have?',
  'faq.sustainability.a1': 'As a company committed to our community, we develop social responsibility initiatives selectively, focusing on projects with real impact in education and community development. Although they are not massive programs, we seek to generate significant change in the communities where we operate.',
  'faq.sustainability.q2': 'How does the group contribute to sustainable development?',
  'faq.sustainability.a2': 'We seek to integrate sustainable practices into our operations when possible, promoting natural products and adopting efficiency measures in our processes. Although we do not have extensive programs, we strive to operate responsibly with the environment.',
  'faq.sustainability.q3': 'What quality measures do you implement in your products?',
  'faq.sustainability.a3': 'We maintain quality standards in all our products and services. Each company in the group implements appropriate quality controls for its sector, ensuring that our customers receive reliable products and services that meet their expectations.',
  'faq.cta.title': 'Didn\'t Find Your Answer?',
  'faq.cta.description': 'Our team is ready to help you with any additional questions',
  'faq.cta.button': 'Contact Us',

  // Opportunity Page
  'opportunity.hero.subtitle': 'Business Model',
  'opportunity.hero.title': 'Your Success Opportunity',
  'opportunity.hero.description': 'Join our multilevel business model and build your financial freedom with the backing of IVG CORP',
  'opportunity.system.title': 'How the System Works',
  'opportunity.system.description': 'A simple and transparent model that allows you to generate income while helping others achieve their goals',
  'opportunity.step1.title': 'Register',
  'opportunity.step1.description': 'Join our network with a minimal initial investment and access all products and training tools',
  'opportunity.step2.title': 'Build Your Network',
  'opportunity.step2.description': 'Invite other entrepreneurs to join and form your team. Each person you add strengthens your income network',
  'opportunity.step3.title': 'Generate Income',
  'opportunity.step3.description': 'Receive commissions from direct sales and residual bonuses from the growth of your distributor network',
  'opportunity.brochure.title': 'Digital Brochure',
  'opportunity.brochure.description': 'Explore our complete catalog with detailed information about products, plans and opportunities',
  'opportunity.brochure.catalog_description': 'Explore our complete catalog of products and business opportunities',
  'opportunity.brochure.download': 'Download PDF',
  'opportunity.testimonials.title': 'Partner Testimonials',
  'opportunity.testimonials.description': 'Learn about the success stories of those who are already part of our network',
  'opportunity.testimonials.level': 'Professional Networker',
  'opportunity.testimonials.achievements': 'Outstanding Achievements',
  'opportunity.testimonial1.name': 'Zulema Carrillo',
  'opportunity.testimonial1.text': 'As a female entrepreneur, IVG CORP gave me the opportunity to shine. I achieved a lifestyle that exceeds my expectations. It is possible!',
  'opportunity.testimonial1.achievements': 'Total independence, Dream lifestyle, Personal fulfillment',
  'opportunity.testimonial2.name': 'Russel Montalvo',
  'opportunity.testimonial2.text': 'The IVG CORP system is extraordinary. In 3 and a half years I achieved an exceptional standard of living. Now I help others achieve their dreams.',
  'opportunity.testimonial2.achievements': 'Successful investments, Superior quality of life, Time freedom',
  'opportunity.testimonial3.name': 'Jhonny Ruiz',
  'opportunity.testimonial3.text': 'Since I reached Diamond level, my life changed radically. I have a lifestyle that I could only imagine before. The key is perseverance.',
  'opportunity.testimonial3.achievements': 'International travel, Premium lifestyle, Total independence',
  'opportunity.testimonial4.name': 'Israel Grijalva',
  'opportunity.testimonial4.text': 'Thanks to IVG CORP I achieved my total financial freedom. In 1 year my lifestyle changed completely. This business transformed my reality.',
  'opportunity.testimonial4.achievements': 'Financial freedom, Luxury travel',
  'opportunity.cta.title': 'Ready to Start?',
  'opportunity.cta.description': 'Join thousands of entrepreneurs who are already building their financial freedom with IVG CORP',
  'opportunity.cta.button': 'More Information',
};